import { Cancel } from "@mui/icons-material";
import { Card, CircularProgress, FormControlLabel, FormGroup, Switch } from "@mui/material";
import ImagePicker from "components/ApnaUploader";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleAlert } from "redux/festures/alertSlice";
import { getBrands } from "redux/festures/brandSlice";
import { getAllEHomeBanner } from "redux/festures/eHomeBannerSlice";
import { updateEHomeBanner } from "redux/festures/eHomeBannerSlice";
import { createEHomeBanner } from "redux/festures/eHomeBannerSlice";
import { createHomeBanner } from "redux/festures/homeBannerSlice";
import { updateHomeBanner } from "redux/festures/homeBannerSlice";
import { getAllHomeBanner, getSingleHomeBanner } from "redux/festures/homeBannerSlice";
import { getGlobalCategory, getNullParentCategory } from "redux/festures/categorySlice";
import ApnaSelect2 from "components/ApnaSelect";
import AstrieskIcon from 'components/AstrieskIcon'

const CreateBranner = ({ isOpen, isOpenUpdate, setIsOpenUpdate, setIsOpen }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [isBrandName, setIsBrandName] = useState("");
  const [isBrandImage, setIsBrandImage] = useState("");
  const [isShow, setIsShow] = useState("");
  const [type, setType] = useState("");
  const [ecommerceCategoryId, setEcommerceCategoryId] = useState("");
  const [serviceCategoryId, setServiceCategoryId] = useState("");
  const [isBrandShowHome, setIsBrandShowHome] = useState(false);
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  const { Loading, AllEHomeBanner, singleEHomeBanner, createUpdateloading } = useSelector((state) => ({
    ...state.isEHomeBanner,
  }));
  const { category: ecommerceCategories, serviceCategory: serviceCategories } = useSelector((state) => ({
    ...state.isCategory,
  }));
  ;
  useEffect(() => {
    if (isOpen) {
      dispatch(getGlobalCategory({ adminId: admin, page: 1, limit: 100 }));
      dispatch(getNullParentCategory(admin));
    }
  }, [isOpen, admin, dispatch]);
  useEffect(() => {
    if (singleEHomeBanner && isOpenUpdate) {
      setIsBrandName(singleEHomeBanner?.title);
      setIsShow(singleEHomeBanner?.banner);
      setType(singleEHomeBanner?.type || "");
      setEcommerceCategoryId(
        typeof singleEHomeBanner?.ecommerceCategoryId === "object"
          ? singleEHomeBanner?.ecommerceCategoryId?._id
          : singleEHomeBanner?.ecommerceCategoryId || ""
      );
      setServiceCategoryId(
        typeof singleEHomeBanner?.serviceCategoryId === "object"
          ? singleEHomeBanner?.serviceCategoryId?._id
          : singleEHomeBanner?.serviceCategoryId || ""
      );
      // setIsBrandShowHome(singleBrands?.showInHome);
    } else {
      setIsBrandName("");
      setIsShow("");
      setType("");
      setEcommerceCategoryId("");
      setServiceCategoryId("");
      // setIsBrandShowHome("");
    }
  }, [singleEHomeBanner, isOpenUpdate, isOpen]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const bannerFile =
      isBrandImage?.[0]?.file ||
      (Array.isArray(isBrandImage) ? isBrandImage[0] : isBrandImage);

    if (bannerFile || (isShow && isShow !== "")) {
      const formData = new FormData();
      formData.append("title", isBrandName || "");
      if (bannerFile) {
        formData.append("banner", bannerFile);
      }
      if (type) {
        formData.append("type", type);
      }
      if (type === "ecommerce" && ecommerceCategoryId) {
        formData.append("ecommerceCategoryId", ecommerceCategoryId);
      } else if (type === "service" && serviceCategoryId) {
        formData.append("serviceCategoryId", serviceCategoryId);
      }

      if (isOpenUpdate) {
        dispatch(
          updateEHomeBanner({
            url: `${process.env.REACT_APP_APII}/eCommerce/updateHomeBanner/${singleEHomeBanner?._id}/${admin}`,
            data: formData,
          })
        ).then((data) => {
          dispatch(
            handleAlert({
              isOpen: true,
              type: `${data?.payload?.success ? "success" : "error"}`,
              msg: data?.payload?.message,
            })
          );
          if (data?.payload?.success) {
            setIsOpen(false);
            setIsOpenUpdate(false);
            setIsBrandName("");
            setIsBrandImage("");
            setType("");
            setEcommerceCategoryId("");
            setServiceCategoryId("");
            dispatch(getAllEHomeBanner(`/eCommerce/getAllHomeBanner/${admin}`));
          }
        });
      } else {
        dispatch(
          createEHomeBanner({
            url: `${process.env.REACT_APP_APII}/eCommerce/createHomeBanner/${admin}`,
            data: formData,
          })
        ).then((data) => {
          dispatch(
            handleAlert({
              isOpen: true,
              type: `${data?.payload?.success ? "success" : "error"}`,
              msg: data?.payload?.message,
            })
          );
          if (data?.payload?.success) {
            setIsOpen(false);
            setIsOpenUpdate(false);
            setIsBrandName("");
            setIsBrandImage("");
            setType("");
            setEcommerceCategoryId("");
            setServiceCategoryId("");
            dispatch(getAllEHomeBanner(`/eCommerce/getAllHomeBanner/${admin}`));
          }
        });
      }
    } else {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "warning",
          msg: "Banner image is required",
        })
      );
    }
  };
  return <>
    <MDBox
      display="flex"
      alignItems="center"
      lineHeight={1}
      sx={{
        justifyContent: "center",
        textAlign: "center",
        flexDirection: "column",
        gap: 2,
        width: "100%",
      }}
    >
      <Card
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 , 10px",
        }}
      >
        <MDTypography variant="h6" py={0.9}>
          {isOpenUpdate ? `Update Banner ` : " Create Banner"}
        </MDTypography>
      </Card>
      <MDBox
        lineHeight={1}
        sx={({ palette: { dark, white, info } }) => ({
          border: 0.5,
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "column",
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          width: "100%",
          p: 3,
          borderColor: darkMode ? white.main : dark.main,
          borderRadius: 3,
        })}
        component="form"
        role="form"
        onSubmit={handleFormSubmit}
      >
        <MDBox
          lineHeight={1}
          width={"100%"}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <MDTypography variant="h6">Select Type (Optional)</MDTypography>
          <ApnaSelect2
            data={[
              { name: "Ecommerce", value: "ecommerce" },
              { name: "Service", value: "service" },
            ]}
            value={type}
            origin="Type"
            onChange={(e) => {
              setType(e.target.value);
              setEcommerceCategoryId("");
              setServiceCategoryId("");
            }}
            name="type"
            nameKey="name"
            valueKey="value"
            isSimpleArray={false}
          />
        </MDBox>

        {type === "ecommerce" && (
          <MDBox
            lineHeight={1}
            width={"100%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">Select Ecommerce Category (Optional)</MDTypography>
            <ApnaSelect2
              data={ecommerceCategories}
              value={ecommerceCategoryId}
              origin="Ecommerce Category"
              onChange={(e) => setEcommerceCategoryId(e.target.value)}
              name="ecommerceCategoryId"
              nameKey="name"
              valueKey="_id"
              isSimpleArray={false}
            />
          </MDBox>
        )}

        {type === "service" && (
          <MDBox
            lineHeight={1}
            width={"100%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">Select Service Category (Optional)</MDTypography>
            <ApnaSelect2
              data={serviceCategories}
              value={serviceCategoryId}
              origin="Service Category"
              onChange={(e) => setServiceCategoryId(e.target.value)}
              name="serviceCategoryId"
              nameKey="name"
              valueKey="_id"
              isSimpleArray={false}
            />
          </MDBox>
        )}
        <MDBox
          lineHeight={1}
          width={"100%"}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <MDTypography variant="h6">
            Home Banner Image{" "}
            <MDTypography variant="body1" component="span" fontSize={11}>
              &nbsp; ( image size - 3200 × 1442 px )
            </MDTypography>
          </MDTypography>
          <ImagePicker

            // required={true}
            name="Brand Image"
            multiple={false}
            images={isBrandImage}
            setImages={setIsBrandImage}
          //
          />

          {!isBrandImage && isShow && (
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <span
                disabled={createUpdateloading}
                style={{
                  display: "inline-block",
                  width: "50px",
                  height: "50px",
                  margin: "0 0.5rem",
                }}
              >
                <img
                  className="Image"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  src={`${process.env.REACT_APP_URI}${isShow}`}
                />
              </span>
              <span
                className="cross"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  setIsShow(null);
                }}
              >
                <Cancel
                  sx={({ palette: { dark, white, info } }) => ({
                    color: darkMode ? white?.main : dark.main,
                  })}
                />
              </span>
            </div>
          )}
        </MDBox>
        {/* <MDBox
            lineHeight={1}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 3,
            }}
          >
            <MDTypography variant="h6">Brand show in home </MDTypography>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    value={isBrandShowHome}
                    checked={isBrandShowHome !== undefined ? isBrandShowHome : false}
                    sx={{ color: "info.main" }}
                    onChange={(e) => setIsBrandShowHome(e.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="show in home"
              />
            </FormGroup>
          </MDBox> */}
        <MDBox
          sx={{
            width: "100%",
            justifyContent: "flex-end",
            textAlign: "center",
            display: "flex",
          }}
        >

          <MDButton disabled={createUpdateloading} color={"info"} verdant={"gradient"} type={"submit"}>
            {createUpdateloading ? (
              <CircularProgress size={20} color="primary" />
            ) : isOpenUpdate ? (
              `Update Banner`
            ) : (
              ` Create Banner`
            )}

          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  </>

};

export default CreateBranner;
CreateBranner.propTypes = {
  isOpenUpdate: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.any,
  setIsOpenUpdate: PropTypes.any,
  isOpen: PropTypes.any,
  //   setIsSwitch: PropTypes.func,
  //   isSwitch: PropTypes.any,
  //   productId: PropTypes.string,
  //   updateProductModal: PropTypes.bool,
  //   setUpdateProductModal: PropTypes.bool,
};
